import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output , signal} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { Role } from '../../../../../constants/enum/common/role-enum';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ModalType } from '../../../../../models/common/modal/modal-config';
import { AuthStoreService } from '../../../../../state/modules/auth/auth-store.service';
import { HandoverNotesService } from '../../../../../state/modules/handover-notes/handover-notes.service';
import { FileViewerComponent } from '../../../../shared/components/form-components/components/file-viewer/file-viewer.component';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { NotificationComponent } from '../../../../shared/components/modals/notification/notification.component';
import { HANDOVER_NOTES_TYPE } from '../../pages/handover-notes/handover-notes.constant';
import { HandoverNotesAcknowledgedListComponent } from '../handover-notes-acknowledged-list/handover-notes-acknowledged-list.component';
import { HandoverNotesActionComponent } from '../handover-notes-action/handover-notes-action.component';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { MasterService } from '../../../../../state/master/services/master.service';

@Component({
  standalone: false,
  selector: 'kt-handover-notes-comments',
  templateUrl: './handover-notes-comments.component.html',
  styleUrls: ['./handover-notes-comments.component.scss']
})
export class HandoverNotesCommentsComponent extends ModalBaseClass implements OnInit {

  handoverListData;
  acknowledgeIds = [];
  userInfo;
  userId;

  @Input() set _userId(data) {
    if(data) {
      this.userId = data;
    } else {
      this.userId = LocalStorageUtil.getUserId();
    }
  }

  @Input() activeTab;
  @Input() totalCount;
  @Input() set _handoverListData(data) {
    if (data) {
      this.handoverListData = data;
      // this.acknowledgeIds = this.handoverListData.forEach(data => {
      //   data.hand_over_note_acknowledge.forEach(ack => {
      //     this.acknowledgeIds.push(ack.hand_over_note_acknowledge_fk_user_id)
      //   });
      // });
      // console.log('====user id=====', this.userInfo, this.handoverListData, this.acknowledgeIds);
    }
  };

  @Output() callback = new EventEmitter();
  @Output() scrollCallback = new EventEmitter();
  @Output() refresh = new EventEmitter();
  permissionConstant = PERMISSION_CONSTANT;
  PermissionV2 = PERMISSIONV2

  @Input() set _loading(data) {
    this.loading = data;
  }

  dataById;
  roleRef = Role;
  loading = signal(false);
  disableButton = false;
  acknowledgedByList;
  loginUserProfile = null;
  subscriptions: Subscription[] = [];
  handoverNotesTypes = HANDOVER_NOTES_TYPE;
  masterBusinessLabel = MasterService.masterBusinessLabel


  appendData = false;
  lastPayload = {
    page_number: 1,
    page_size: 20,
  };

  constructor(
    public modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authStoreService: AuthStoreService,
    public handoverNotesService: HandoverNotesService
  ) {
    super(modalService)
  }

  ngOnInit() {
    this.subscriptions.push(this.authStoreService.selectUser().subscribe(user => {
      if (user && user.user_id) {
        this.userInfo = user;
      }
    }));
    this.loginUserProfile = LocalStorageUtil.getUserRole();
  }

  /**
   * Opens Acknowledged by modal popup
   */
  acknowledgedByModalHandler() {
    const modalRef = this.openPopUp(HandoverNotesAcknowledgedListComponent, { acknowledgedByList: this.acknowledgedByList },
      { centered: true, size: 'lg', keyboard: true, backdrop: 'static' },
    );
  }

  /**
   * Used to get acknowledged by data
   * Contains Api call
   * @param data
   */
  acknowledgedList(data) {
    this.loading.set(true);
    this.subscriptions.push(this.handoverNotesService.getHandoverNoteById(data.hand_over_note_id, "acknowledge").subscribe((data: any) => {
      if (data && data.data && data.data.data && data.data.data.hand_over_note) {
        this.acknowledgedByList = data.data.data.hand_over_note.hand_over_note_acknowledge;
        this.acknowledgedByModalHandler();
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
  }

  /**
   * Used to open edit popup and populate data
   * Contains Api call
   * @param data
   */
  editNoteClickHandler(data) {
    this.getNoteDataById(data, true);
    setTimeout(() => {
      const modalRef = this.openPopUp(HandoverNotesActionComponent, { userId: this.userId, defaultEmployeeUserId: this.userInfo.user_id, isEdit: true, editHandoverNote: this.dataById },
        { centered: true, size: 'lg', keyboard: true, backdrop: 'static' },
      );
      modalRef.result.then((result) => {
        if (result && result === "Submit") {
          this.callback.emit();
        }
      });
    }, 100);
  }

  checkForAcknowledge(commentData) {
    const ackIds = (commentData.hand_over_note_acknowledge || []).map(data => data.hand_over_note_acknowledge_fk_user_id);
    return ackIds.includes(this.userInfo.user_business.user_business_fk_user_id);
  }

  /**
   * Used to get data By Id
   * We can get area details, comments and acknowledged by data
   * @param data
   * @param isEdit If it is true, we will get data and populate it in form
   */
  getNoteDataById(data, isEdit = false) {
    this.loading.set(true);
    let type;
    if (isEdit) {
      type = "area";
    } else if (!isEdit) {
      type = "comment";
    }
    this.subscriptions.push(this.handoverNotesService.getHandoverNoteById(data.hand_over_note_id, type).subscribe((data: any) => {
      if (data) {
        this.dataById = data.data.data.hand_over_note;
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
    this.cdr.detectChanges();
  }

  /**
   * Deletes particular Handover Note by using Id
   * Contains Api call
   * @param handoverNote
   */
  deleteNoteClickHandler(handoverNote) {
    this.loading.set(true);
    this.subscriptions.push(this.handoverNotesService.deleteHandoverNote(handoverNote.hand_over_note_id).subscribe((data: any) => {
      if (data.success) {
        this.callback.emit();
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
  }

  /** Click on Delete Handover Note
   * @param deleteNoteConfirmation - button click for deleting handover Note
   */
  deleteNoteConfirmation(handoverNote) {
    // tslint:disable-next-line: no-use-before-declare
    const modalRef = this.modalService.open(NotificationComponent);
    modalRef.componentInstance.options = {
      type: ModalType.DELETE,
      title: 'Confirm',
      message: 'Are you sure you want to delete this Handover Note?',
    };
    modalRef.result.then((data) => {
      if (data && data.STATUS === 'delete') {
        this.deleteNoteClickHandler(handoverNote);
      }
    }, (error) => { });
  }

  /**
   * It is used for viewing uploaded files
   */
  fileViewerHandler(data) {
    this.openPopUp(FileViewerComponent, { fileUrl: data.hand_over_note_upload_1 },
      { centered: true, size: 'xl', keyboard: true, backdrop: 'static' },
    );
  }

  /**
   * Used for marking handover Note as Acknowledged for a particular user
   * Contains Api call
   * @param handoverNote
   */
  acknowledgeClickHandler(handoverNote) {
    this.loading.set(true);
    const payload = {
      hand_over_note_acknowledge_fk_hand_over_notes_id: handoverNote.hand_over_note_id
    }
    this.subscriptions.push(this.handoverNotesService.handoverNoteAcknowledge(payload).subscribe((data: any) => {
      if (data.success) {
        this.callback.emit();
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
  }

  /** Click on Acknowledge Handover Note
   * @param acknowledgeConfirmation - button click for marking handover Note as Acknowledged
   */
  acknowledgeConfirmation(handoverNote) {
    // tslint:disable-next-line: no-use-before-declare
    const modalRef = this.modalService.open(NotificationComponent);
    modalRef.componentInstance.options = {
      type: ModalType.SUCCESS_CONFIRM,
      title: 'Confirm',
      message: 'Are you sure you want to mark this Handover Note as Acknowledged?',
    };
    modalRef.result.then((data) => {
      if (data && data.STATUS === 'ok') {
        this.acknowledgeClickHandler(handoverNote);
      }
    }, (error) => { });
  }

  /**
   * Used for marking any particular handover Note as Completed
   * Contains Api call
   * @param handoverNote
   */
  completedClickHandler(handoverNote) {
    this.loading.set(true);
    this.subscriptions.push(this.handoverNotesService.handoverNoteDone({}, handoverNote.hand_over_note_id).subscribe((data: any) => {
      if (data.success) {
        this.refresh.emit(true);
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
  }

  /** Click on Completed Handover Note
   * @param completedConfirmation - button click for marking handover Note as Completed
   */
  completedConfirmation(handoverNote) {
    // tslint:disable-next-line: no-use-before-declare
    const modalRef = this.modalService.open(NotificationComponent);
    modalRef.componentInstance.options = {
      type: ModalType.SUCCESS_CONFIRM,
      title: 'Confirm',
      message: 'Are you sure you want to mark this Handover Note as Completed?',
    };
    modalRef.result.then((data) => {
      if (data && data.STATUS === 'ok') {
        this.completedClickHandler(handoverNote);
      }
    }, (error) => { });
  }

  /**
 * On Scroll load the new data as needed
 */
  onScroll() {
    // if (this.totalCount > (this.lastPayload.page_number) * this.lastPayload.page_size) {
    //   this.lastPayload.page_number = this.lastPayload.page_number + 1;
    //   this.appendData = true;
    //   this.scrollCallback.emit(this.lastPayload);
    // }
    this.scrollCallback.emit(true);
  }

}
